import React from "react";
import Reveal from "./Reveal";

/**
 * Not Lost. Unstructured.
 *
 * Diagnostic section that reframes the visitor's situation without
 * pathologizing it. Sits between "Where Do You Fit?" and the
 * Structured Momentum Method so the visitor moves from
 * self-identification, to honest naming, to method.
 *
 * The tone is grounded and short. Not a sales argument. Not a
 * coaching cliche. Just a quiet diagnosis.
 */

const STATEMENTS = [
  "You may have the vision.",
  "You may have the gifts.",
  "You may have the relationships.",
  "You may even have momentum.",
];

const NotLostUnstructured = () => (
  <section
    id="not-lost"
    data-testid="not-lost-section"
    className="relative py-24 md:py-32 border-t border-gold/10"
  >
    <div className="max-w-3xl mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-[11px] tracking-[0.5em] uppercase text-gold mb-6 text-center">
          The Real Block
        </p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-themed leading-[1.08] tracking-tight font-light text-center">
          You are not lost.{" "}
          <span className="italic gold-gradient-text">You may be unstructured.</span>
        </h2>
      </Reveal>

      <Reveal delay={160}>
        <ul
          data-testid="not-lost-statements"
          className="mt-12 space-y-2 text-center"
        >
          {STATEMENTS.map((s, i) => (
            <li
              key={i}
              className="text-white/85 text-[16.5px] md:text-[17.5px] leading-relaxed font-serif italic"
            >
              {s}
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={260}>
        <div className="mt-12 bg-white/5 border-t border-gold/20 p-7 md:p-9 rounded-lg border border-gold/10">
          <p
            data-testid="not-lost-bridge-line"
            className="text-white/85 text-[16px] md:text-[17px] leading-relaxed"
          >
            You may not need more motivation. You may need a clearer way to organize what is already in motion.
          </p>
          <p className="mt-5 text-white/85 text-[16px] md:text-[17px] leading-relaxed">
            Authentic Momentum helps you slow down enough to see what is actually happening, clarify what matters, and build the next structure that allows movement to become real.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default NotLostUnstructured;
